import React from "react";
import { FaInstagram, FaLinkedin, FaFacebook } from 'react-icons/fa';

function Footer() {
  return (
    <div className="border-t border-black md:p-0 p-4 md:py-8 py-4 text-sm">
      <div className="container mx-auto flex md:flex-row flex-col justify-between">
        <div className="flex flex-col md:flex-row">
          <p className="pr-4 md:border-r border-r-0 border-black">
            GST Number : 04AEOFS3330M1ZS
          </p>
          <p className="md:pl-4 pl-0">© 2023, Synswift Infotech LLP</p>
        </div>
        <div className="flex flex-row items-center gap-4">
          <div className="font-normal">Follow us:</div> 
          <a 
            href="https://www.instagram.com/synswift/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2"
          >
            <FaInstagram className="w-5 h-5 text-pink-600" />
           
          </a>
          <a 
            href="https://www.linkedin.com/company/synswift-infotech/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2"
          >
            <FaLinkedin className="w-5 h-5 text-blue-600" />
           
          </a>
          <a 
            href="https://www.facebook.com/Synswift/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2"
          >
            <FaFacebook className="w-5 h-5 text-blue-700" />
           
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
